import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const StepButton = styled.button`
    display: flex;
    align-items: center;
    gap: ${theme.space[16]};
    height: ${theme.sizes[24]};
    border-radius: ${theme.radii[4]};
    color: inherit;
    text-align: left;
    white-space: nowrap;

    &:focus-visible {
        box-shadow: ${theme.shadows.focus};
    }
`;
